// NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import {
  currentQuestionBlockSelector,
  questionsForBlockSelector,
  answersSelector,
  actionsInProgress,
} from 'selectors';
import { withRouter } from 'react-router';

import Layout from 'Components/Layout/Layout';
import PreviousBlockButton from 'Components/Pages/Survey/PreviousBlockButton';
import CommitBlockButton from 'Components/Pages/Survey/CommitBlockButton';

// External Components
import { QuestionHolder } from 'frontend-component-library';

class Survey extends Component {
  setAnswers = (id, answer) => {
    this.props.submitAnswer(id, answer);
  };

  componentDidMount = () => {
    this.props.startOrResumeSurvey();
  };

  componentDidUpdate = prevProps => {
    const { currentQuestionBlockId } = this.props;
    if (prevProps.currentQuestionBlockId !== currentQuestionBlockId) {
      this.scrollToTop();
    }
  };

  scrollToTop = () => {
    if (!this.surveyElement) {
      return;
    }
    const surveyOffset = this.surveyElement.offsetTop;
    window.scrollTo({ top: surveyOffset });
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.surveyComplete) {
      this.props.history.push('/results/generate');
    }
  };

  renderQuestions = () => {
    const { questions } = this.props;
    return questions.map(question => {
      const { id } = question;
      const answer = this.props.answers[id];
      return (
        <QuestionHolder
          key={id}
          {...question}
          displayType={question.display_type}
          answer={answer}
          onChange={this.setAnswers}
        />
      );
    });
  };

  render() {
    const {
      questions,
      answers,
      currentQuestionBlockId,
      commitQuestionBlock,
      canCommit,
    } = this.props;
    if (this.props.currentQuestionBlock) {
      return (
        <Layout>
          <div
            ref={node => (this.surveyElement = node)}
            className="Survey-holder"
          >
            <div className="Survey">{this.renderQuestions()}</div>
            <div className="Survey-btn-holder">
              <PreviousBlockButton />
              <CommitBlockButton
                questions={questions}
                answers={answers}
                currentQuestionBlockId={currentQuestionBlockId}
                commitQuestionBlock={commitQuestionBlock}
                isLoading={canCommit}
              />
            </div>
          </div>
        </Layout>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  const block = currentQuestionBlockSelector(state);
  const questions = questionsForBlockSelector(state, block);

  return {
    currentQuestionBlock: block,
    currentQuestionBlockId: state.survey.currentQuestionBlockId,
    questions,
    answers: answersSelector(state, questions),
    surveyComplete: state.survey.surveyComplete,
    canCommit: actionsInProgress(state, 'blockState'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      startOrResumeSurvey: actions.startOrResumeSurvey,
      submitAnswer: actions.submitAnswer,
      commitQuestionBlock: actions.commitQuestionBlock,
    },
    dispatch
  );
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Survey));



// WEBPACK FOOTER //
// ./src/Components/Pages/Survey/Survey.js